import React from 'react'
import styled from 'styled-components'
import { Content, Title } from './CommentItem'
import arrowLeft from '../../static/images/icons/arrow_left_2.png'
import './comment.scss'
const ReplyContainer = styled.li`
color: #3c444d;
font-size: 2rem;
padding:0 20px;
margin-bottom: 20px;
overflow-wrap: break-word;
margin-right:30px;
@media screen and (min-width: 750px) {
    margin-right:50px;
    font-size:2.3rem;
    padding: 20px;
    margin-bottom: 0px;
    }
`
const InfoBlock = styled.div`
margin-bottom:9px;

&.meta-block{
    font-size:85%;
    padding-right: 20px;
    
    > label{
        margin-left:10px;
    }
}
`
const TitleBlock = styled(InfoBlock)`
position:relative;
font-weight:700;
font-size:20px;
padding-right: 20px;
margin-bottom:7px;

`
const Indicator = styled.span`
position:absolute;
right:-24px;
img{
    width:18px;
    padding-right:20px;
}
`
const ReplyItem = (props) => {
    return (
        <ReplyContainer className="comment-cotainer">
            <TitleBlock>
                <Indicator>
                    <img src={arrowLeft} alt="" />
                </Indicator>
                <Title>{props.title}</Title>
            </TitleBlock>
            <InfoBlock className="meta-block">
                <label>{props.author}</label>
                <label>{props.publishDate}</label>
            </InfoBlock>
            <InfoBlock>
                <Content>{props.content}</Content>
            </InfoBlock>
        </ReplyContainer>
    )
}

export default ReplyItem;


// WEBPACK FOOTER //
// ./src/Components/comments/ReplyItem.jsx